import Footer from './footer'

export default Footer



// WEBPACK FOOTER //
// ./src/components/common/footer/index.js